import { useEffect } from 'react';
import { useMarketConfig } from '~/app/market-config';
import { CompareLayerWrapper } from '~/app/pages/configurator/components/compare-layer-wrapper';
import { DialogProps } from '~/app/pages/summary/dialogs/dialog-props';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { LayerType } from '~/app/tracking/feld-m-types';
import { Dialog } from '~/components/dialog';
import { useCatalog, useConfigurator } from '~/graphql/hooks/use-configurator';
import { useConfiguredCarTechnicalDataLazyQuery } from '~/graphql/hooks/use-configured-car-queries';
import { DriveTrain } from '~/graphql/mapper';

export function StandardEquipmentDialog({ open, onClose }: DialogProps) {
	useEffect(() => {
		if (open) {
			appTrackingService.updateLayerComponent(LayerType.StandardEquipmentLayer, 'open');
			appTrackingService.viewChangeEvent({
				eventName: `configurator - ${LayerType.StandardEquipmentLayer}`,
				componentName: 'standard-equipment',
			});
		}
	}, [open]);

	return (
		<Dialog open={open} onCloseButtonClick={onClose}>
			{open && <StandardEquipmentDialogContent open={open} />}
		</Dialog>
	);
}

const StandardEquipmentDialogContent = ({ open }: { open: boolean }) => {
	const { config } = useMarketConfig();
	const { trimlines } = useCatalog();
	const carConfig = useConfigurator();
	const driveTrain = trimlines?.flatMap((t) => t.driveTrains)?.find((d) => d.status.selected);
	const { fetchTechnicalData, data: technicalData, loading } = useConfiguredCarTechnicalDataLazyQuery();

	useEffect(() => {
		open &&
			config.hasTechnicalDataEnabled &&
			config.showCaESummaryText &&
			fetchTechnicalData({
				variables: {
					configuredCar: {
						...carConfig.carIdentifier,
					},
				},
			});
	}, [open]);

	const configuredCarTechData = technicalData?.configuredCar?.technicalDataV2;

	const drivetrainWithConfiguredCAE = configuredCarTechData
		? ({
				...driveTrain,
				__item: {
					...driveTrain?.__item,
					technicalDataV2: {
						...driveTrain?.techData,
						consumptionAndEmission: configuredCarTechData?.consumptionAndEmission,
					},
				},
			} as DriveTrain)
		: driveTrain;

	return (
		<>
			{driveTrain && drivetrainWithConfiguredCAE && !loading && (
				<CompareLayerWrapper
					key="standard-equipment-dialog"
					setIsOpen={() => {}}
					open={open}
					selectedDriveTrain={drivetrainWithConfiguredCAE}
					config={{
						selectedTab: 'standardEquipment',
						isDisabled: true,
					}}
				/>
			)}
		</>
	);
};
